import {Portal} from '@mui/material';
import React, {ReactNode} from 'react';

interface PortalWrapperProps {
    children: ReactNode;
    container?: Element;
}

export const PortalWrapper = ({children, container}: PortalWrapperProps) => {

    if (container) {
        return <Portal container={container}>

            {children}
        </Portal>
    }

    return children
}
